module.exports = ":host{display:flex;flex-grow:1}:host svg{width:100%;height:450px;overflow:visible;z-index:1}\n"